import moment from 'moment';
import React from 'react';
import AppSpinner from '../../../components/app-spinner';
import {Expense} from '../../../components/expenses-detail/ExpensesDetail';
import Header2 from '../../../components/headers/header2';
import {Row} from '../../../components/layout';
import ModalTemplate from '../../../components/modal';
import PreAuthorizationsDetail from '../../../components/pre-authorizations-detail/PreAuthorizationsDetail';
import colors from '../../../util/colors';
import * as fonts from '../../../util/fonts';
import {strings} from '../../../util/strings';
import {PreAuthorizationItem} from '../PreAuthorizations';
import PreAuthorizationListItemStatus from './PreAuthorizationListItemStatus';
import './styles.scss';

type AuthorizationDetailProps = {
  setShowModal(value: boolean): void;
  showModal: boolean;
  labels: typeof strings.pt.preAuthorizations;
  selectedItem: PreAuthorizationItem | undefined;
  expenses: Expense[];
  user: any;
  documents: any[];
  color: string;
  preAuthDetail: any;
  loading: any;
  statuses: {
    value: string;
    label: string;
    statedId: string;
    colorCode: string;
  }[];
};

function PreAuthorizationDetail(props: AuthorizationDetailProps) {
  let statusId = props.selectedItem?.decisionState;
  let currentStatus = props.statuses.find((e) => e.value == statusId);
  let color = currentStatus?.colorCode;
  let stateDescription = currentStatus?.label;

  return (
    <ModalTemplate
      className="reimbursement-detail-modal-pre-auth"
      show={props.showModal}
      onHide={() => props.setShowModal(false)}
      cross={true}
      hideFooter={true}>
      <Header2
        style={{...fonts.XL, color: colors.black, fontWeight: 'bolder'}}
        className="reimbursement-history-modal-header">
        {props.labels?.refund_preAuthorization_detail_title}
      </Header2>
      {!props.loading ? (
        <>
          <Row className="reimbursement-history-modal-subtitle pre-authorization-detail-status-row">
            <Row
              style={{...fonts.ML}}
              className="reimbursement-history-modal-status pre-authorizations-status-label">
              <PreAuthorizationListItemStatus
                stateDescription={stateDescription}
                color={color}
              />
            </Row>
          </Row>
          <PreAuthorizationsDetail
            estadoId={props.selectedItem?.providerName}
            process={props.selectedItem?.serviceNumber}
            documents={props.documents}
            selectedPatient={`${
              props.selectedItem?.providerName?.split(/(\s+)/)[0]
            } ${props.selectedItem?.providerName?.split(/(\s+)/)[6]}`}
            preAuthDetail={props.preAuthDetail}
            occorenceDate={moment(props.selectedItem?.dos)
              .format('DD-MM-YYYY')
              .toUpperCase()}
            provider={props.selectedItem?.clinicName}
            procedure={props.selectedItem?.svcGrp}
            submittedFiles={[]}
            type={props.selectedItem?.clinicName.toUpperCase()}
          />
        </>
      ) : (
        <AppSpinner
          style={{
            width: 'fit-content',
            margin: 'auto',
            marginTop: '5%',
            marginBottom: '10%',
          }}
        />
      )}
    </ModalTemplate>
  );
}

export default PreAuthorizationDetail;
